export default __webpack_public_path__ + "static/media/gallery_03.f19c61b7.jpg";